<template>
  <div id="background">
    <Nav />
    <Header />
    <v-row justify="center" style="width: 100%; margin: 0px">
      <v-col
        align-self="center"
        xs="12"
        sm="12"
        md="8"
        lg="6"
        xl="4"
        style="padding: 0px"
      >
        <booking-card v-if="!configEnabled('Enable maintenance')" />
        <maintenance :msg="getConfigValue('Maintenance message')" v-else />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from "axios";
import BookingCard from "../components/BookingCard.vue";

import Header from "../components/Header";
import Maintenance from "../components/Maintenance.vue";
import Nav from "../components/Nav.vue";
import { configEnabled } from "../helpers";

export default {
  name: "Home",
  methods: {
    configEnabled(name) {
      return configEnabled(name, this.$store.getters.getConfigs);
    },

    getConfigValue(name) {
      const configs = this.$store.getters.getConfigs;
      const config = configs.find((c) => c.name === name);
      return config ? config.value : "";
    },

    getConfigs() {
      axios({
        url: `${process.env.VUE_APP_BASE_URL ?? ""}/api/getconfigs`,
        method: "GET",
        headers: { Authorization: localStorage.getItem("Authorization") },
      })
        .then((resp) => {
          const configs = resp.data.configs ?? [];
          this.configs = configs;
          configs.forEach((c) => {
            if (
              c.name === "Show MVR amount to customers" &&
              c.value !== "true"
            ) {
              this.showMVRAmount = false;
            } else if (c.name === "Cent discount for same day return trip") {
              this.sameDayReturnCentDiscount = parseInt(c.value);
            } else if (c.name === "Laari discount for same day return trip") {
              this.sameDayReturnLaariDiscount = parseInt(c.value);
            } else if (
              c.name ===
                "Require customer names to be entered when making booking" &&
              c.value === "false"
            ) {
              this.requireCustomerNames = false;
            } else if (
              c.name === "Prevent customers from booking return trips" &&
              c.value === "true"
            ) {
              this.preventReturnTrip = true;
            }
          });
          this.$store.dispatch("configure", {
            configs,
          });
        })
        .catch((error) => {
          if (error.response) {
            this.errorMessage(error.response.data.error);
          }
        })
        .finally(() => {});
    },
  },
  mounted() {
    this.getConfigs();
  },
  components: {
    Header,
    BookingCard,
    Maintenance,

    Nav,
  },
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
}

#app {
  background-color: #f2f3f6;
}
</style>
